<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Course wise evaluation</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item">Reports</li>
              <li class="breadcrumb-item active">
                Course wise evaluation
              </li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <a
              href="javascript:void(0)"
              class="btn btn-info"
              @click="showFilter = !showFilter"
            ><i class="fa fa-filter"></i>Filter</a
            >
          </div>
          <form @submit.prevent="getFilterData" method="GET" novalidate>
            <div class="card-body" v-if="showFilter">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="course_title"
                    >Course title</label
                    >
                    <div class="col-md-9">
                      <input
                        type="text"
                        id="course_title"
                        class="form-control"
                        v-model="filter.course_title"
                        placeholder="course title"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <!--<div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="course_id"
                    >Course ID</label
                    >
                    <div class="col-md-9">
                      <input
                        type="text"
                        id="course_id"
                        class="form-control"
                        v-model="filter.course_id"
                        placeholder="course id"
                      />
                    </div>
                  </div>-->
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-9 offset-md-3">
                      <button type="submit" class="btn btn-common m-2px">
                        Search
                      </button>
                      <button
                        type="reset"
                        class="btn btn-warning"
                        @click="resetFilter()"
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <div class="card-body table-responsive-md p-0">
            <table class="table">
              <thead>
              <tr>
                <th>Course Title</th>
                <th>Total Watch Time (In Minutes)</th>
                <th>No of Users who completed this course</th>
                <th>No of users who have not completed this course yet</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in items.data">
                <td>{{ item.course ? item.course.course_title : 'NA' }}</td>
                <td class="text-center">{{ item.total_watch_duration }}</td>
                <td class="text-center">{{ item.completed_100_percent_count }}</td>
                <td class="text-center">{{ item.below_100_percent_count }}</td>
              </tr>
              </tbody>
            </table>

            <div class="p-4" v-if="_.isEmpty(items.data)">
              <div class="alert alert-default-warning" role="alert">
                No data found!
              </div>
            </div>
          </div>

          <div class="card-footer">
            <vue-pagination
              :pagination="items"
              v-if="items.total > items.per_page"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import { LearningReportApi } from "@/services/api";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "CourseWiseEvaluation",
  metaInfo: {
    title: "Course wise evaluation| Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
  },
  data: () => ({
    items: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    showFilter: false,
    filter: {},
    is_loading: false,
  }),
  methods: {
    getItems() {
      this.filter = JSON.parse(JSON.stringify(this.$route.query));
      if (!_.isEmpty(this.filter)) this.showFilter = true
      this.is_loading = true
      let params = { ...this.filter, ...this.$route.query }
      LearningReportApi.courseWiseEvaluation(params)
        .then((items) => {
          this.items = items
        })
        .finally(() => {
          this.is_loading = false
        });
    },
    resetFilter() {
      this.$router.push({ path: this.$route.path }).catch(() => {})
    },
    async getFilterData() {
      this.$router
        .push({
          path: this.$route.fullPath,
          query: this.filter,
        })
        .catch((err) => {
          console.log(err)
        });
    },
  },
  mounted() {
    this.getItems()
  },
};
</script>
